import { createSlice } from "@reduxjs/toolkit"
import { signIn, signOut, signUp, forgotPassword, resetPassword, updateProfile, fetchUser, fetchUserOrders } from "../actions/authActions"

const UserReducers = createSlice({
  name: "UserReducers",
  initialState: {
    token: null,
    userDetails: {},
    orders: null,
    message: null,
    loader: false,
    errors: null,
  },
  reducers: {
    clearUserData: (state) => {
      console.log('clearUserData reducer called');
      state.token = null;
      state.userDetails = {};
      state.message = null;
      state.errors = null;
      // Clear token from localStorage
      localStorage.removeItem('token');
    },
  },
  extraReducers: (builder) => {
    builder
    
      /**
       * Sign Up User
       */
      .addCase(signUp.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(signUp.fulfilled, (state, action) => {
          state.loader = false;

          const { token, user, message } = action.payload;
          state.token = token; // Store the token
          state.userDetails = user; // Store the user details
          state.message = message; // Store the response message

          // Store token in localStorage for axios interceptor
          if (token) {
              localStorage.setItem('token', token);
          }
      })
      .addCase(signUp.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Sign In User
       */
      .addCase(signIn.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
          state.loader = false;

          const { token, user, message } = action.payload;
          state.token = token; // Store the token
          state.userDetails = user; // Store the user details
          state.message = message; // Store the response message

          // Store token in localStorage for axios interceptor
          if (token) {
              localStorage.setItem('token', token);
          }
      })
      .addCase(signIn.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Sign Out User
       */
      .addCase(signOut.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(signOut.fulfilled, (state, action) => {
          state.loader = false;

          const { message } = action.payload;
          state.token = null;
          state.userDetails = {};
          state.message = message; // Store the response message

          // Clear token from localStorage
          localStorage.removeItem('token');
      })
      .addCase(signOut.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
          console.log("auth Reducers signout:", action.payload)
      })
      /**
       * Forgot Password User
       */
      .addCase(forgotPassword.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(forgotPassword.fulfilled, (state) => {
          state.loader = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Reset Password User
       */
      .addCase(resetPassword.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(resetPassword.fulfilled, (state) => {
          state.loader = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Fetch User Data
       */
      .addCase(fetchUser.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
          state.loader = false;
          state.userDetails = action.payload; // Update user details with fresh data
      })
      .addCase(fetchUser.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Update Profile User
       */
      .addCase(updateProfile.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
          state.loader = false;
          state.userDetails = action.payload; // Update user details with the response
          state.message = 'Profile updated successfully';
      })
      .addCase(updateProfile.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Fetch User Orders
       */
      .addCase(fetchUserOrders.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(fetchUserOrders.fulfilled, (state, action) => {
          state.loader = false;
          state.orders = action.payload; // Store orders with pagination data
      })
      .addCase(fetchUserOrders.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
  },
});

export const { clearUserData } = UserReducers.actions;

export default UserReducers.reducer;